import { connect } from 'react-redux';
import { goBack, goForward, push, replace } from '../../module';

export const injectProps = connect(undefined, {
    push,
    replace,
    goBack,
    goForward,
});
